/**
 * La marca de Instagram, dibujada a linea.
 *
 * No es el logotipo oficial a proposito: ese viene con relleno y degradado de
 * color, y aca no hay mas que blanco, negro y grises. Se dibuja al trazo, con
 * el mismo 1px de las flechas de la galeria, y toma el color del texto que
 * tiene al lado.
 *
 * El viewBox va en las mismas unidades que el tamano en pantalla para que ese
 * trazo caiga justo en un pixel y no salga gris por el antialias.
 */
export default function IconoInstagram({ tamano = 14 }) {
  return (
    <svg
      width={tamano}
      height={tamano}
      viewBox="0 0 14 14"
      fill="none"
      aria-hidden="true"
      focusable="false"
      className="icono-instagram"
    >
      <rect x="0.5" y="0.5" width="13" height="13" rx="3.6" stroke="currentColor" />
      <circle cx="7" cy="7" r="3" stroke="currentColor" />
      <circle cx="10.7" cy="3.3" r="0.85" fill="currentColor" />
    </svg>
  );
}
